import { colors } from "../../../../assets/styles/tokens";

// Shared mobile-only score-color bands — distinct from the desktop
// getScoreMeta's Strong/Moderate/Weak thresholds (>=7/>=4) and literal hex
// colors. This uses the 1-4/5-7/8-10 ranges mapped to the design tokens'
// error/warning/success families, so every mobile surface (lead card,
// scoring rationale) shows the same color for the same score.
export interface MobileScoreMeta {
  label: string;
  color: string;
  bg: string;
}

export function getMobileScoreMeta(score: number): MobileScoreMeta {
  if (score >= 8) return { label: "Strong", color: colors.Success[600].$value, bg: colors.Success[50].$value };
  if (score >= 5) return { label: "Moderate", color: colors.Warning[600].$value, bg: colors.Warning[50].$value };
  return { label: "Weak", color: colors.Error[600].$value, bg: colors.Error[50].$value };
}
